// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"color-list_wrapper__2rnz_","title":"color-list_title__3i7o7","list":"color-list_list__1jOKu","placeholder":"color-list_placeholder__19GHQ"};